<template>
<section class="view-wrap three-quarters">
	<div class="title-wrap m-b-2 flex align-center space-between wrap">
		<Heading :level="2" text="Forgot Password" />
	</div>
	<p class="m-b-1">
		You can update your password below.
		Simply enter your account email address below and click submit.
		An email with a verification link will be sent to the email provided to complete the process.
	</p>
	<UserMessage class="m-t-2" v-if="userFeedback.message" :message-type="userFeedback.type" :message-text="userFeedback.message" />

	<form @submit.prevent="resetPassword" novalidate ref="form">
		<form-field-set>
			<template #legend>
				<legend class="sr-only">Please enter your email address</legend>
			</template>
			<template #fields>
				<InputField
					name="username"
					ref="username"
					label-text="Email"
					placeholder="me@example.com"
					:value="formData.username"
					@emitFieldData="(val) => formData.username = val"
					input-type="email"
					required-error="Please provide your email address"
					:validation-rules="[rules.validateEmail]"
					:is-disabled="userFeedback.readonly" />
			</template>
		</form-field-set>

		<Button
			class="primary m-t-3"
			button-type="submit"
			text="Submit"
			loading-text="Submitting"
			:is-disabled="formSubmitting || userFeedback.readonly"
			:is-loading="formSubmitting"
			@btnClick="resetPassword" />
	</form>
</section>
</template>

<script>
import { mapActions } from 'vuex';
import { validationRules } from '@/utilities/validationRules';
import { formValidator } from '@/mixins/formValidator';

export default {
	name: 'ForgotPasswordView',
	mixins: [formValidator],
	data: () => ({
		formSubmitting: false,
		rules: validationRules,
		formData: {
			username: ''
		},
		userFeedback: {
			type: null,
			message: null,
			readonly: false
		}
	}),
	methods: {
		resetPassword () {
			this.userFeedback = {
				type: null,
				message: null,
				readonly: true
			};
			if (this.isValid(this.$refs.form)) {
				this.formSubmitting = true;
				this.forgotPassword(this.formData).then((res) => {
					this.userFeedback = {
						type: 'success',
						message: 'Thank you, if that address is registered with us we’ll send you an email with instructions to reset your password. Please check your spam folder just in case.',
						readonly: true
					};
				}).catch((err) => {
					this.userFeedback = {
						type: 'error',
						message: err.message
					};
				}).finally(() => {
					this.formSubmitting = false;
				});
			} else {
				this.userFeedback = {
					type: 'error',
					message: 'Please provide a valid email address.'
				};
			}
		},
        ...mapActions('auth', ['forgotPassword'])
	}
};
</script>
